module.exports = __webpack_public_path__ + "static/app-formato-beneficiario-2-849d2c987928d2461c8decda509f7e4a.svg";